import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { IconButton, TableCell, TableRow, Tooltip, withStyles } from '@material-ui/core';
import Timestamp from 'react-timestamp';
import DeleteIcon from '@material-ui/icons/Delete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ROLE_USER } from '../../constants/roles';
import { deleteBook } from '../../store/books/actions';

const styles = () => (
  {
    fabProgress: {
      color: 'primary',
      position: 'absolute',
      top: -6,
      left: -6,
      zIndex: 1,
    },
  }
);

export class BookingsRow extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      sendingBookId: '',
      role: ROLE_USER,
    };
  }

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.role) {
      const role = props.roles[props.authUser.uid];
      newState = {
        ...newState,
        role,
      };
    }
    if (!props.sending && state.sendingBookId) {
      newState = {
        ...newState,
        sendingBookId: null,
      };
    }
    return newState;
  }

  handleDeleteBook = (event) => {
    this.setState({ sendingBookId: this.props.book.id });
    this.props.deleteBook(
      this.props.authUser.ma,
      this.props.book.id,
      this.state.role,
    );
    event.preventDefault();
  };

  render() {
    const {
      book,
      classes,
    } = this.props;

    const { sendingBookId } = this.state;

    return (
      <TableRow
        key={book.id}
        hover
        tabIndex={-1}
      >
        <TableCell>
          <Timestamp
            format="full"
            twentyFourHour
            time={book.date} />
        </TableCell>
        <TableCell numeric>{book.nb_adult_bikes}</TableCell>
        <TableCell numeric>{book.nb_children_bikes}</TableCell>
        <TableCell>{book.username}</TableCell>
        <TableCell padding="checkbox">
          <Tooltip title="Supprimer">
            <IconButton
              aria-label="delete"
              onClick={this.handleDeleteBook}
            >
              <DeleteIcon />
              {this.props.sending && sendingBookId === this.props.book.id &&
              <CircularProgress size={58} className={classes.fabProgress} />}
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
    sending: state.books.sending,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { deleteBook }),
)(BookingsRow);



// WEBPACK FOOTER //
// ./src/components/Bookings/BookingsRow.jsx